<template>
  <div class="select_product">
    <div class="select_accessory">
      <p class="heading">LOOKING TO RETROFIT ONE OF YOUR <br/> ACCESSORIES WITH ZWIFLOC™? </p>
      <p class="sub_heading">Select or search for your accessory from the dropdown menu</p>
      <div class="product_selection">
          <v-select :filter="fuseSearch"  v-model="selectedProduct" class="product_dropdown" :get-option-label="(option) => option.title" placeholder="Select" :options="products" @input="getProductAccessories" >
            <template #header>
              <div class="selection_header">Select your product</div>
            </template>
            <template #selected-option="option">
              {{option.stockCode}} - {{option.title}}
            </template>

            <template class="dropdown_options" slot="option" slot-scope="option">
                <div class="option_main" style="border-bottom: 1px solid rgba(220, 220, 220, 1);">
                  <div class="option_img" style="width: 40%; display: flex; align-items: center;">
                    <img :src="option.defaultImage" alt="accessory" width="80px">
                  </div>
                  <div class="option_details">
                    <p>
                      <span class="option_details_stockcode">{{option.stockCode}}</span>
                      <span class="option_details_title"><br/>{{option.title}}</span>
                    </p>
                  </div>
                </div>
            </template>
            <template v-slot:no-options>
              <p class="no_option_text">
              If your accessory is not on this list, <br/> it cannot retrofit with Zwifloc
              </p>
              </template>
          </v-select>
      </div>
    </div>

    <div class="results_section" v-if="selectedProduct">
          <p class="result_heading">Your Results</p>
          <p class="result_subheading">The following spare parts will be required to make your accessory compatible with the Zwifloc™ fastening system.</p>
          <div class="container results">
            
            <div class="retrofit_accessories" v-for="(accessory,index) in accessories" :key="index">
              <div class="retrofit_details">
                <div class="accessory_image" style="width: 40%; display: flex; align-items: center;">
                  <img :src="accessory.defaultImage" alt="accessory" width="120px">
                </div>
                <div class="accessory_detail">
                  <div class="detail_heading">
                    <p class="stockCode">{{accessory.stockCode}} </p> 
                    <a class="title" :href=" '/product/' + accessory.stockCode">{{accessory.title}}</a>
                  </div>
                  <div class="detail_price">
                      <p class="price" v-if="accessory.productPrice">{{ accessory.productPrice }}</p>
                      <p class="price" v-else>$0.00</p>
                      <div class="detail_qty">
                        <p> (RRP INC GST)</p>
                        <p class="qty">QTY <strong> {{accessory.qty}} </strong></p>
                      </div>
                  </div>
                </div>
              </div>
              <div class="wishlist_button">
                <div class="add_to_wishlist">
                  <wishlist-zwifloc
                      :data="[{
                        'class' : 'btn-primary',
                          'stockCode' : accessory.stockCode,
                          'netSuiteId' : accessory.netSuiteId,
                          'productId' : accessory.productId2,
                          'quantity' : accessory.qty,
                      }]"
                      :add_to_wishlist = "'Add to Wishlist'"
                      :added_to_wishlist = "'Added to WishList'"
                      :label_view_wishlist = "'View Wishlist'"
                      :label_continue_shopping = "'Continue Shopping'"
                      :enable_b2c = enable_b2c
                      :enable_b2b = enable_b2b
                      >
                  </wishlist-zwifloc>
                </div>
              </div>
            </div>

          </div>

          <div class="accessory_wishlist">
            <hr class="bottom">

            <wishlist-multiple
            v-if="renderWishList"
                :data="[{
                  'class' : 'btn-primary',
                  'accessories': accessories,
                }]"
                :add_to_wishlist = "'Add to Wishlist'"
                :added_to_wishlist = "'Added to WishList'"
                :label_view_wishlist = "'View Wishlist'"
                :label_continue_shopping = "'Continue Shopping'"
                :enable_b2c = enable_b2c
                :enable_b2b = enable_b2b
                >
            </wishlist-multiple>
          </div>
    </div>

    <div class="reselect_products" v-if="selectedProduct">
        <p @click="searchAgain">Search for another product</p>
    </div>

  </div>
</template>

<script>
  import Axios from 'axios';
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";
  import Fuse from 'fuse.js';
  export default {
    props: {
        add_to_wishlist: {
            type: String,
            default: "Add to Wish List"
        },
        added_to_wishlist: {
            type: String,
            default: "Added to Wish List"
        },
        label_view_wishlist: {
            type: String,
            default: "View Wish List"
        },
        label_continue_shopping: {
            type: String,
            default: "Continue Shopping"
        },
        ga_tracking_category: {
            type: String,
            default: "WishList"
        },
        ga_tracking_action: {
            type: String,
            default: "Click"
        },
        ga_tracking_label: {
            type: String,
            default: "Button"
        },
        enable_b2c: {},
        enable_b2b: {},
    },
    data() {
      return {
        selectedProduct: undefined,
        products: [],
        selectedItem: '',
        accessories: [],
        renderWishList: true,
      };
    },
    mounted() {
      this.loadProducts();
    },
    methods: {
      
      loadProducts: function(){
        Axios
        .get("/getZwiflocAccessory")
        .then((response) => {
            this.products = response.data;
        })
        .catch(function(error){
            console.log(error);
        });
      },
      async getProductAccessories(e){
        this.accessories = [];
        this.selectedItem = `${e.stockCode}`;
        Axios.
        post(`/` + window.culture + `/getZwiflocItemDetails`,{product: this.selectedItem})
          .then((response) => {
            this.accessories = response.data;
          });
          this.renderWishList = false;
          await this.$nextTick();
          this.renderWishList = true;
      },
      searchAgain(){
        this.accessories = [];
        this.selectedProduct = undefined;
      },
      fuseSearch(options, search) {
        const fuse = new Fuse(options, {
          keys: ['stockCode', 'title'],
          shouldSort: true,
        })
        return search.length
          ? fuse.search(search).map(({ item }) => item)
          : fuse.list
    },
    }
  }
</script>

<style lang="scss">
  
  .select_product{
    padding-bottom: 150px;
    padding-top: 100px;
    background-color: #005CB9;
    font-family: trim-regular;

    .select_accessory{
        color: #FFFFFF;
        text-align: center;

        @media only screen and (max-width: 767px) {
          padding-left: 15px;
          padding-right: 15px;
        }

      .heading{
        font-weight: 500;
        letter-spacing: 0.54px;
        line-height: 34px;
        font-size: 28px;

        @media only screen and (max-width: 767px) {
            font-size: 22px;
          }
      }

      .sub_heading{
          opacity: 0.61;
          font-weight: 300;
          font-size: 16px;
          letter-spacing: 0.31px;
          line-height: 19px;
      }

      .product_selection{
        display: flex;
        flex-direction: column;
        align-items: center;

        .product_dropdown{
          background-color: #FFFFFF;
          color: #0F1720;
          width: 417px;
          font-size: 16px;
          font-weight: 300;
          letter-spacing: 0.31px;
          line-height: 19px;

          @media only screen and (max-width: 492px) {
            width: 85%;
          }

          @media only screen and (max-width: 405px) {
            width: 90%;
          }

          @media only screen and (max-width: 383px) {
            width: 96%;
          }

          @media only screen and (max-width: 361px) {
            width: 100%;
          }

          
          .selection_header{
            color: #FFFFFF; 
            background-color: #005CB9; 
            font-size: 16px; 
            letter-spacing: 0; 
            line-height: 22px; 
            text-align: start; 
            padding-bottom: 3px;
          }

          .vs__dropdown-toggle{
            height: 50px;

              .vs__selected-options{ 
                color: #0F1720;
                font-family: trim-regular; 
                letter-spacing: 0.31px;
                font-weight: 300;
                font-size: 16px;
                line-height: 19px;

              input::placeholder{
                opacity: 0.31; 
              }
            }
          }

          .option_main{
            display: flex;
            flex-direction: row;
            gap: 10px;
            white-space: pre-wrap;
            
            .option_details{
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              width: 100%;
              // max-height: 51.67px;
                .option_details_stockcode{
                  color: #0F1720; 
                  opacity: 0.61; 
                  font-family: trim-regular; 
                  font-size: 16px; 
                  letter-spacing: 0.31px; 
                  line-height: 19px; 
                  font-weight: 300;
                }
                .option_details_title{
                  color: #0F1720; 
                  font-family: trim-regular; 
                  font-size: 16px; 
                  letter-spacing: 0; 
                  line-height: 22px; 
                  font-weight: 550;
                }
            }
          }
        

        }

        .no_option_test{
          padding-top: 5px;
          padding-bottom: 5px;
        }
        
      }

    }

  .results_section{
      background-color: #00468C !important;
      font-family: trim-regular;
      padding-top: 37px;
      margin-top: 48px;

    .result_heading{
      color: #FFFFFF;
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0.46px;
      line-height: 28px;
      text-align: center;
    }

    .result_subheading{
      opacity: 0.61;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 300;
      letter-spacing: 0.31px;
      line-height: 19px;
      text-align: center;
      padding-bottom: 15px;

      @media only screen and (max-width: 767px) {
        padding-left: 12px;
        padding-right: 12px;
      }

    }


    .results{
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: center;

      .retrofit_accessories{
        display: flex;
        flex-direction: column;
        gap: 20px;

        .retrofit_details{
          display: flex;
          flex-direction: row;
          gap: 11px;
          background-color: #FFFFFF;
          max-width: 345px;
          min-height: 165px;

          .accessory_detail{
              font-size: 15px;
              padding-right: 10px;
              font-family: trim-regular;
              display: flex;
              flex-direction: column;
              justify-content: space-around;

            .detail_heading{
              letter-spacing: 1.25px;
              font-weight: 500;
              text-transform: uppercase;
              margin-top: 5px;

              .stockCode{
                margin-bottom: -1px;
              }

              .title{
                color: #025CB9;
                font-weight: 800;
                margin-bottom: 1rem;
              }
            }
            .detail_price{
              display: flex;
              flex-direction: column;
              padding-top: 10px;

              .price{
                font-weight: 800;
                margin-bottom: 0;
              }

              .detail_qty{
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .qty{
                  border-left: 1px solid #DCDCDC;
                  padding-left: 20px;
                  
                }
              }
            }
          }
        }
        .wishlist_button{
          .add_to_wishlist {
            a {
                text-align: center;
            }
        }
        .bottom-link{
            text-decoration: none !important;
            width: 100%;
          }
        }

      }

    }

    .accessory_wishlist{
      text-align: center;
      padding-bottom: 41px;
      .bottom{
        width: 72%;
        border: 1px solid #FFFFFF;
        opacity: 0.23;
        margin-bottom: 40px;
      }

      .add_all_wishlist{
        width: 345px;
        height: 50px;

        @media only screen and (max-width: 467px) {
            width: 80%;
          }
      }
    }
  }

  .reselect_products{
    background-color: #005CB9;
    text-align: center;
    padding-top: 31px;
    margin-bottom: -126px;

    p{
      font-family: trim-regular;
      cursor: pointer;
      text-decoration: underline;
      color: #FFFFFF;
      font-size: 15px;
      font-weight: 500;
      letter-spacing: 0.29px;
      line-height: 18px;
      text-align: center;
    }
  }


  }

</style>